import { keyframes } from "styled-components";

export const appear = keyframes`
    from {
        opacity : 0;
    }
    to{
        opacity : 1;
    }
`